import Request from '../v1/request'

const Simcard_Binding = {
    getSimcardBindingIndex(fid, callback, bad_answer) {
        Request.get('simcard-binding/index/' + fid).then(callback).catch(bad_answer)
    },
    getSimcardBindingList(callback) {
        Request.get('simcard-binding/list/').then(callback).catch(this.bad_answer)
    },
    getTemplateSimcardBinding(id, callback) {
        Request.get('simcard-binding/get-template/' + id).then(callback).catch(this.bad_answer)
    },
    createBindSimcardBinding(params, callback) {
        Request.post('simcard-binding/create-bind', JSON.stringify(params)).then(callback).catch(this.bad_answer)
    },
    updateBindSimcardBinding(id, params, callback) {
        Request.post('simcard-binding/update-bind/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
    },
    checkSimcardForSimcardBinding(params, callback) {
        Request.post('simcard-binding/check-simcard', JSON.stringify(params)).then(callback).catch(this.bad_answer)
    },
    deleteSimcardBinding(id, callback, bad_answer) {
        Request.delete('simcard-binding/simcard/' + id).then(callback).catch(bad_answer)
    },
}
export default Simcard_Binding
